import { Suspense, useEffect, useState } from "react";
import { Badge, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import ToolTip from "../../../Components/CustomComponents/ToolTip.js";
import EditFMModal from "../../../Components/Modals/EditFMModal.js";
import {
  useUpdateEAMutation
} from "../../../Data/services/earlyAccessApi.js";
import { useDeleteFMMutation, useGetAllFMQuery } from "../../../Data/services/foundMemberApi.js";
import Toast, { SuccessToast } from "../../../Hooks/useToast.js";

export const useFoundingMember = () => {
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [dataFetched, setDataFetched] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { data, isLoading, isFetching, refetch } = useGetAllFMQuery(
    {
      search: searchQuery.length >= 3 ? searchQuery : "",
      limit: pageSize,
      page: currentPage,
    },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (data) {
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleDeleteModalOpen = () => setDeleteModal(true);
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleConfirmModalOpen = () => setConfirmModal(true);
  const handleConfirmModalClose = () => {
    setConfirmModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => setEditModal(true);
  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => setEditModal(true);

  const [deleteFoundingMember, { isLoading: isDeleting }] = useDeleteFMMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteFoundingMember(slug);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      Toast(error.message, "error");
    }
  };

  const [selectedType, setSelectedType] = useState("");

  // const [uploadAttachment, { isLoading: isUploadingFile }] =
  //   useUploadAttachmentMutation();
  // const [uploadCSV, { isLoading: isSendingFile }] = useUploadCSVMutation();

  // const handleUploadDirectCSV = async (file) => {
  //   if (!file) return;
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("path", "admin");

  //   try {
  //     const uploadResponse = await uploadAttachment({ formData }).unwrap();
  //     const uploadedFileUrl = uploadResponse.data[0];
  //     setFileUrl(uploadedFileUrl);

  //     if (uploadedFileUrl) {
  //       const csvResponse = await uploadCSV({
  //         file_url: uploadedFileUrl,
  //       }).unwrap();
  //       if (csvResponse.code === 200) {
  //         refetch();
  //         SuccessToast(csvResponse?.message);
  //         handleConfirmModalClose();
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Upload error:", error);
  //     Toast("Failed to upload file", "error");
  //   }
  // };

  const [update, { isLoading: updating }] = useUpdateEAMutation();

  const handleDynamicTypeChange = async (value, row) => {
    setSelectedType(value);
    const data = { incentive_tier: value };
    try {
      const response = await update({ data, id: row.id }).unwrap();
      if (response.code === 200) {
        refetch();
        SuccessToast(response?.message);
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  function indication() {
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "email",
      text: "Email",
      headerStyle: { width: "300px" },
      formatter: (cellContent, row) => (
        <span className="lc-2 table-column-full">{cellContent}</span>
      ),
    },
    {
      dataField: "special_code",
      text: "Special Code",
      headerStyle: { width: "150px" },
      formatter: (cellContent, row) => (
        <Badge pill className="large" >{cellContent} </Badge>
      ),
    },
    {
      dataField: "activated",
      text: "Activated",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
      formatter: (cellContent, row) => (
        <Badge pill bg="secondary" >{cellContent === 1 ? "Yes" : "No"} </Badge>
      ),
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "100px" },
      formatter: (cellContent, row) => {
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <ToolTip placement={"top"} content={"Delete"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setEditedData(row);
                    handleDeleteModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center`}>
                    <MdDeleteForever />
                  </span>
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  const Modals = () => (
    <>
      {/* {confirmModal && (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <ConfirmUploadCSVModal
            handleDeleteModalClose={handleConfirmModalClose}
            onDirectUpload={handleUploadDirectCSV}
            uploadingFile={isUploadingFile}
            sendingFile={isSendingFile}
          />
        </Suspense>
      )} */}
      {editModal && (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditFMModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      )}
    </>
  );

  return {
    rowData,
    columns,
    indication,
    totalRecords,
    totalPages,
    pageSize,
    currentPage,
    searchQuery,
    handleSearchChange,
    setCurrentPage,
    setPageSize,
    refetch,
    dataFetched,
    isFetching,
    isLoading,
    Modals,
    handleAddUser,
    handleConfirmModalOpen,
    deleteModal,
    handleDeleteModalClose,
    editedData,
    isDeleting,
    deleteData,
  };
};
